document.addEventListener('DOMContentLoaded', function () {
	var faqPage = document.querySelector('.content-page[data-page-handle="faq"]');
	var isRefundPolicyPage = window.location.pathname === '/policies/refund-policy';
	var returnsRequestForm = document.querySelector('[data-returns-form-wrap] form');

	if (faqPage) {
		enhanceFaqPage(faqPage);
	}

	if (isRefundPolicyPage) {
		enhanceRefundPolicyPage();
	}

	if (returnsRequestForm) {
		enhanceReturnRequestForm(returnsRequestForm);
	}

	initLauraJaneAnalytics();
	initLuxuryCommerceExperience();
});


function ljTrack(eventName, params) {
	var payload = params || {};

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(Object.assign({ event: eventName }, payload));

	if (typeof window.gtag === 'function') {
		window.gtag('event', eventName, payload);
	}
}

function getLauraJaneCurrency() {
	return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'ZAR';
}

function buildLauraJaneItemFromCard(card, fallbackIndex) {
	if (!card) {
		return null;
	}

	return {
		item_id: card.dataset.productId || card.dataset.selectedVariantId || '',
		item_name: card.dataset.productTitle || '',
		item_variant: card.dataset.selectedVariantTitle || '',
		item_list_name: card.dataset.itemListName || card.dataset.collectionTitle || (document.querySelector('[data-collection-list]') ? document.querySelector('[data-collection-list]').dataset.collectionTitle : '') || '',
		index: Number(card.dataset.productIndex || fallbackIndex || 0),
		price: Number(card.dataset.selectedVariantPriceCents || 0) / 100
	};
}

function buildLauraJaneItemFromProduct(section) {
	if (!section) {
		return null;
	}

	return {
		item_id: section.dataset.productId || section.dataset.selectedVariantId || '',
		item_name: section.dataset.productTitle || '',
		item_variant: section.dataset.selectedVariantTitle || '',
		price: Number(section.dataset.selectedVariantPriceCents || 0) / 100
	};
}

function initLauraJaneAnalytics() {
	var collectionList = document.querySelector('[data-collection-list]');
	var productCards = Array.from(document.querySelectorAll('.collection-product[data-product-card-root]'));
	var productSection = document.querySelector('[data-main-product]');

	if (collectionList && productCards.length) {
		ljTrack('view_item_list', {
			currency: getLauraJaneCurrency(),
			item_list_name: collectionList.dataset.collectionTitle || '',
			items: productCards.map(function (card, index) {
				return buildLauraJaneItemFromCard(card, index);
			}).filter(Boolean)
		});
	}

	document.addEventListener('click', function (event) {
		var productLink = event.target.closest('[data-product-card-link]');
		var paginationLink = event.target.closest('[data-pagination-link]');
		var checkoutLink = event.target.closest('a[href*="/checkout"], button[name="checkout"], [data-checkout-button]');

		if (productLink) {
			var card = productLink.closest('[data-product-card-root]');
			var item = buildLauraJaneItemFromCard(card, card ? card.dataset.productIndex : 0);

			if (item) {
				ljTrack('select_item', {
					currency: getLauraJaneCurrency(),
					item_list_name: item.item_list_name || '',
					items: [item]
				});
			}
		}

		if (paginationLink) {
			ljTrack('laurajane_pagination_click', {
				collection: collectionList ? collectionList.dataset.collectionTitle || '' : '',
				target: paginationLink.dataset.paginationTarget || paginationLink.textContent.trim()
			});
		}

		if (checkoutLink) {
			ljTrack('begin_checkout', {
				currency: getLauraJaneCurrency()
			});
		}
	}, { capture: true });

	if (productSection) {
		var item = buildLauraJaneItemFromProduct(productSection);
		if (item) {
			ljTrack('view_item', {
				currency: getLauraJaneCurrency(),
				items: [item]
			});
		}
	}
}

function trackLauraJaneAddToCart(variantId, trigger) {
	var card = trigger ? trigger.closest('[data-product-card-root]') : null;
	var item = buildLauraJaneItemFromCard(card, 0) || {
		item_id: String(variantId || ''),
		item_variant: String(variantId || ''),
		quantity: 1
	};

	item.quantity = 1;
	if (!item.item_variant) {
		item.item_variant = String(variantId || '');
	}

	ljTrack('add_to_cart', {
		currency: getLauraJaneCurrency(),
		items: [item]
	});
}

function enhanceFaqPage(faqPage) {
	var body = faqPage.querySelector('.content-page__body');

	if (!body || body.dataset.faqEnhanced === 'true') {
		return;
	}

	var paragraphs = Array.from(body.children).filter(function (element) {
		return element.tagName === 'P';
	});

	var faqParagraphs = paragraphs.filter(function (paragraph) {
		return /q\s*:/i.test(paragraph.textContent) && /a\s*:/i.test(paragraph.textContent);
	});

	if (!faqParagraphs.length) {
		return;
	}

	var introParagraph = paragraphs.find(function (paragraph) {
		return !faqParagraphs.includes(paragraph);
	});

	if (introParagraph) {
		introParagraph.classList.add('content-page__intro');
	}

	var faqList = document.createElement('div');
	faqList.className = 'faq-list';

	faqParagraphs.forEach(function (paragraph, index) {
		var entry = parseFaqEntry(paragraph);

		if (!entry.question || !entry.answer) {
			return;
		}

		var item = document.createElement('details');
		item.className = 'faq-item';
		item.open = index === 0;

		var summary = document.createElement('summary');
		summary.className = 'faq-item__question';
		summary.textContent = entry.question;

		var answer = document.createElement('div');
		answer.className = 'faq-item__answer';

		var answerParagraph = document.createElement('p');
		answerParagraph.textContent = entry.answer;
		answer.appendChild(answerParagraph);

		item.appendChild(summary);
		item.appendChild(answer);
		faqList.appendChild(item);
	});

	if (!faqList.children.length) {
		return;
	}

	faqParagraphs[0].before(faqList);
	faqParagraphs.forEach(function (paragraph) {
		paragraph.remove();
	});

	body.dataset.faqEnhanced = 'true';
}

function parseFaqEntry(paragraph) {
	var rawHtml = paragraph.innerHTML.replace(/<br\s*\/?>/gi, '\n');
	var parser = document.createElement('div');
	parser.innerHTML = rawHtml;

	var text = (parser.textContent || '')
		.replace(/\u00a0/g, ' ')
		.replace(/\s+/g, ' ')
		.trim();

	var combinedMatch = text.match(/q\s*:\s*(.+?)\s*a\s*:\s*(.+)/i);

	if (combinedMatch) {
		return {
			question: combinedMatch[1].trim(),
			answer: combinedMatch[2].trim()
		};
	}

	return {
		question: '',
		answer: ''
	};
}

function enhanceRefundPolicyPage() {
	var policyBody = document.querySelector('.shopify-policy__body .rte');

	if (!policyBody || policyBody.querySelector('.policy-support-card')) {
		return;
	}

	var supportCard = document.createElement('section');
	supportCard.className = 'policy-support-card';
	supportCard.innerHTML = [
		'<h2 class="policy-support-card__title">Start a return or exchange</h2>',
		'<p class="policy-support-card__text">To help us process your request faster, submit your order number, order email, and item details through our return request page.</p>',
		'<ul class="policy-support-card__list">',
		'<li>Use the form for returns, exchanges, damaged items, or incorrect orders.</li>',
		'<li>Items should be unused, in original packaging, with tags attached where applicable.</li>',
		'<li>Damaged or incorrect items should be reported within 7 days of delivery.</li>',
		'</ul>',
		'<div class="policy-support-card__actions">',
		'<a class="policy-support-card__link" href="/pages/log-a-return">Log a return</a>',
		'<span class="policy-support-card__note">Once approved, we will email the next steps and shipping guidance.</span>',
		'</div>'
	].join('');

	policyBody.appendChild(supportCard);
}

function enhanceReturnRequestForm(form) {
	var messageField = form.querySelector('[name="contact[body]"]');

	if (!messageField) {
		return;
	}

	form.addEventListener('submit', function () {
		messageField.value = buildReturnRequestMessage(form);
	});
}

function buildReturnRequestMessage(form) {
	var submittedAt = new Date();
	var fields = [
		['Request type', getFormValue(form, 'contact[Request Type]')],
		['Preferred outcome', getFormValue(form, 'contact[Preferred Outcome]')],
		['Order number', getFormValue(form, 'contact[Order Number]')],
		['Order email', getFormValue(form, 'contact[email]')],
		['Customer name', getFormValue(form, 'contact[Name]')],
		['Phone number', getFormValue(form, 'contact[Phone]')],
		['Items', getFormValue(form, 'contact[Items]')],
		['Reason', getFormValue(form, 'contact[Reason]')]
	];
	var details = getFormValue(form, 'contact[Return Details]');
	var lines = [
		'Laura Jane Movement Return Request',
		'',
		'Submitted: ' + submittedAt.toLocaleString(),
		'Source page: ' + window.location.href,
		''
	];

	fields.forEach(function (entry) {
		var label = entry[0];
		var value = entry[1] || '-';
		lines.push(label + ': ' + value);
	});

	lines.push('');
	lines.push('Details:');
	lines.push(details || '-');

	return lines.join('\n');
}

function getFormValue(form, name) {
	var field = form.querySelector('[name="' + name.replace(/"/g, '\\"') + '"]');

	if (!field) {
		return '';
	}

	if (field.tagName === 'SELECT') {
		return field.options[field.selectedIndex] ? field.options[field.selectedIndex].text.trim() : '';
	}

	return field.value.trim();
}

var WISHLIST_STORAGE_KEY = 'laurajane:wishlist:v1';
var quickAddState = {
	card: null,
	product: null,
	selections: [],
	activeVariant: null
};

function initLuxuryCommerceExperience() {
	if (!document.body || document.body.dataset.luxuryCommerceReady === 'true') {
		return;
	}

	document.body.dataset.luxuryCommerceReady = 'true';
	document.addEventListener('click', handleLuxuryCommerceClick);
	document.addEventListener('keydown', handleLuxuryCommerceKeydown);
	window.addEventListener('storage', syncWishlistUi);
	window.addEventListener('hashchange', syncLuxuryCommerceHashState);
	syncWishlistUi();
	renderWishlistDrawer();
	syncLuxuryCommerceHashState();
}

function syncLuxuryCommerceHashState() {
	if (window.location.hash === '#wishlist') {
		openWishlistDrawer({ syncHash: false });
		return;
	}

	closeWishlistDrawer({ syncHash: false });
}

function handleLuxuryCommerceClick(event) {
	var wishlistOpenTrigger = event.target.closest('[data-wishlist-open]');
	var wishlistCloseTrigger = event.target.closest('[data-wishlist-close]');
	var wishlistButton = event.target.closest('[data-wishlist-button]');
	var wishlistRemove = event.target.closest('[data-wishlist-remove]');
	var wishlistAddToCart = event.target.closest('[data-wishlist-add-to-cart]');
	var quickAddTrigger = event.target.closest('[data-quick-add-trigger]');
	var quickAddOption = event.target.closest('[data-quick-add-option]');
	var quickAddClose = event.target.closest('[data-quick-add-close]');
	var quickAddSubmit = event.target.closest('[data-quick-add-submit]');

	if (wishlistOpenTrigger) {
		event.preventDefault();
		openWishlistDrawer();
		return;
	}

	if (wishlistCloseTrigger) {
		event.preventDefault();
		closeWishlistDrawer();
		return;
	}

	if (wishlistButton) {
		event.preventDefault();
		event.stopPropagation();
		toggleWishlistFromCard(wishlistButton.closest('[data-product-card-root]'), wishlistButton);
		return;
	}

	if (wishlistRemove) {
		event.preventDefault();
		removeWishlistItem(wishlistRemove.dataset.wishlistRemove);
		return;
	}

	if (wishlistAddToCart) {
		event.preventDefault();
		addVariantToCart(wishlistAddToCart.dataset.variantId, wishlistAddToCart, 'Added to cart');
		return;
	}

	if (quickAddTrigger) {
		event.preventDefault();
		event.stopPropagation();
		handleQuickAddTrigger(quickAddTrigger.closest('[data-product-card-root]'), quickAddTrigger);
		return;
	}

	if (quickAddOption) {
		event.preventDefault();
		selectQuickAddOption(quickAddOption);
		return;
	}

	if (quickAddClose) {
		event.preventDefault();
		closeQuickAddSheet();
		return;
	}

	if (quickAddSubmit) {
		event.preventDefault();
		submitQuickAdd(quickAddSubmit);
	}
}

function handleLuxuryCommerceKeydown(event) {
	var interactiveControl = event.target.closest('[data-wishlist-button], [data-quick-add-trigger]');

	if (interactiveControl && (event.key === 'Enter' || event.key === ' ')) {
		event.preventDefault();
		interactiveControl.click();
		return;
	}

	if (event.key === 'Escape') {
		closeQuickAddSheet();
		closeWishlistDrawer();
	}
}

function readWishlist() {
	try {
		var storedValue = window.localStorage.getItem(WISHLIST_STORAGE_KEY);
		var parsedValue = storedValue ? JSON.parse(storedValue) : [];

		if (!Array.isArray(parsedValue)) {
			return [];
		}

		return parsedValue.filter(function (item) {
			return item && item.productId;
		});
	} catch (error) {
		return [];
	}
}

function writeWishlist(items) {
	try {
		window.localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(items));
	} catch (error) {
		return;
	}
}

function syncWishlistUi() {
	var items = readWishlist();
	var itemIds = items.map(function (item) {
		return String(item.productId);
	});

	document.querySelectorAll('[data-wishlist-count-badge]').forEach(function (badge) {
		badge.textContent = String(items.length);
		badge.hidden = items.length === 0;
		badge.classList.toggle('hidden', items.length === 0);
	});

	document.querySelectorAll('[data-wishlist-count-inline]').forEach(function (inlineCount) {
		inlineCount.textContent = items.length > 0 ? '(' + items.length + ')' : '';
	});

	document.querySelectorAll('[data-product-card-root]').forEach(function (card) {
		var productId = card.dataset.productId;
		var isSaved = productId ? itemIds.includes(String(productId)) : false;

		card.querySelectorAll('[data-wishlist-button]').forEach(function (button) {
			button.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
			button.classList.toggle('is-active', isSaved);
		});
	});

	renderWishlistDrawer();
}

function toggleWishlistFromCard(card, trigger) {
	if (!card) {
		return;
	}

	var productId = String(card.dataset.productId || '');
	var items = readWishlist();
	var nextItems = items.slice();
	var existingIndex = nextItems.findIndex(function (item) {
		return String(item.productId) === productId;
	});

	if (existingIndex > -1) {
		nextItems.splice(existingIndex, 1);
	} else {
		nextItems.unshift(buildWishlistItemFromCard(card));
	}

	writeWishlist(nextItems);
	animateActionTrigger(trigger, existingIndex > -1 ? '' : 'is-active');
	syncWishlistUi();
	if (existingIndex === -1) {
		openWishlistDrawer();
	}
}

function buildWishlistItemFromCard(card) {
	return {
		productId: String(card.dataset.productId || ''),
		title: card.dataset.productTitle || '',
		url: card.dataset.productUrl || '#',
		image: card.dataset.productImage || '',
		price: card.dataset.selectedVariantPrice || '',
		variantId: card.dataset.selectedVariantId || '',
		variantTitle: formatVariantLabel(card.dataset.selectedVariantTitle || ''),
		available: String(card.dataset.selectedVariantAvailable || '') === 'true'
	};
}

function formatVariantLabel(value) {
	if (!value || value === 'Default Title') {
		return '';
	}

	return value;
}

function renderWishlistDrawer() {
	var container = document.querySelector('[data-wishlist-content]');
	var items = readWishlist();

	if (!container) {
		return;
	}

	if (!items.length) {
		container.innerHTML = [
			'<div class="wishlist-drawer__empty">',
			'<p class="wishlist-drawer__empty-title">Your future favorites live here.</p>',
			'<p class="wishlist-drawer__empty-copy">Tap the heart on any product card to save it for later.</p>',
			'</div>'
		].join('');
		return;
	}

	container.innerHTML = [
		'<div class="wishlist-drawer__list">',
		items
			.map(function (item) {
				var addAction = item.variantId && item.available
					? '<button class="wishlist-card__button wishlist-card__button--primary" type="button" data-wishlist-add-to-cart data-variant-id="' + escapeMarkup(item.variantId) + '">Add to cart</button>'
					: '<a class="wishlist-card__button wishlist-card__button--primary" href="' + escapeMarkup(item.url) + '">View product</a>';

				return [
					'<article class="wishlist-card">',
					'<a class="wishlist-card__media" href="' + escapeMarkup(item.url) + '">',
					item.image ? '<img src="' + escapeMarkup(item.image) + '" alt="' + escapeMarkup(item.title) + '">' : '',
					'</a>',
					'<div class="wishlist-card__content">',
					'<p class="wishlist-card__title">' + escapeMarkup(item.title) + '</p>',
					item.variantTitle ? '<p class="wishlist-card__variant">' + escapeMarkup(item.variantTitle) + '</p>' : '',
					item.price ? '<p class="wishlist-card__price">' + escapeMarkup(item.price) + '</p>' : '',
					'<div class="wishlist-card__actions">',
					addAction,
					'<button class="wishlist-card__button wishlist-card__button--ghost" type="button" data-wishlist-remove="' + escapeMarkup(item.productId) + '">Remove</button>',
					'</div>',
					'</div>',
					'</article>'
				].join('');
			})
			.join(''),
		'</div>'
	].join('');
}

function removeWishlistItem(productId) {
	var nextItems = readWishlist().filter(function (item) {
		return String(item.productId) !== String(productId);
	});

	writeWishlist(nextItems);
	syncWishlistUi();
}

function openWishlistDrawer(options) {
	var drawer = document.querySelector('[data-wishlist-drawer]');
	var shouldSyncHash = !options || options.syncHash !== false;

	if (!drawer) {
		return;
	}

	closeQuickAddSheet();
	drawer.hidden = false;
	drawer.setAttribute('aria-hidden', 'false');
	document.body.classList.add('has-wishlist-open');

	if (shouldSyncHash && window.location.hash !== '#wishlist') {
		window.history.replaceState(null, '', '#wishlist');
	}
}

function closeWishlistDrawer(options) {
	var drawer = document.querySelector('[data-wishlist-drawer]');
	var shouldSyncHash = !options || options.syncHash !== false;

	if (!drawer || drawer.hidden) {
		return;
	}

	drawer.hidden = true;
	drawer.setAttribute('aria-hidden', 'true');
	document.body.classList.remove('has-wishlist-open');

	if (shouldSyncHash && window.location.hash === '#wishlist') {
		window.history.replaceState(null, '', window.location.pathname + window.location.search);
	}
}

function handleQuickAddTrigger(card, trigger) {
	var product = getProductData(card);
	var currentVariant = getCurrentVariant(card, product);
	var mode = card ? card.dataset.quickAddMode : 'chooser';
	var isPreorder = Boolean(currentVariant && currentVariant.preorder && currentVariant.preorder.enabled);

	if (!product || !card) {
		return;
	}

	if (mode === 'direct' && currentVariant && currentVariant.available && !isPreorder) {
		addVariantToCart(currentVariant.id, trigger, 'Added to cart');
		return;
	}

	openQuickAddSheet(card, product, currentVariant);
	animateActionTrigger(trigger, 'is-active');
}

function getProductData(card) {
	var script;

	if (!card) {
		return null;
	}

	if (card.__productData) {
		return card.__productData;
	}

	script = card.querySelector('[data-product-json]');

	if (!script) {
		return null;
	}

	try {
		card.__productData = JSON.parse(script.textContent);
	} catch (error) {
		card.__productData = null;
	}

	return card.__productData;
}

function getCurrentVariant(card, product) {
	var selectedVariantId;

	if (!card || !product || !Array.isArray(product.variants)) {
		return null;
	}

	selectedVariantId = String(card.dataset.selectedVariantId || '');

	return product.variants.find(function (variant) {
		return String(variant.id) === selectedVariantId;
	}) || product.variants.find(function (variant) {
		return variant.available;
	}) || product.variants[0] || null;
}

function openQuickAddSheet(card, product, currentVariant) {
	var modal = document.querySelector('[data-quick-add-sheet]');
	var image = document.querySelector('[data-quick-add-image]');
	var title = document.querySelector('[data-quick-add-title]');
	var price = document.querySelector('[data-quick-add-price]');
	var link = document.querySelector('[data-quick-add-link]');
	var preorderNote = document.querySelector('[data-quick-add-preorder-note]');
	var initialVariant = currentVariant || product.variants.find(function (variant) {
		return variant.available;
	}) || product.variants[0] || null;

	if (!modal || !initialVariant) {
		window.location.href = card.dataset.productUrl || product.url || window.location.href;
		return;
	}

	closeWishlistDrawer();
	quickAddState.card = card;
	quickAddState.product = product;
	quickAddState.selections = Array.isArray(initialVariant.options) ? initialVariant.options.slice() : [];
	quickAddState.activeVariant = initialVariant;

	if (image) {
		image.src = initialVariant.image || product.image || card.dataset.productImage || '';
		image.alt = product.title || '';
	}

	if (title) {
		title.textContent = product.title || '';
	}

	if (price) {
		price.textContent = initialVariant.price || card.dataset.selectedVariantPrice || '';
	}

	if (link) {
		link.href = initialVariant.url || product.url || card.dataset.productUrl || '#';
	}

	if (preorderNote) {
		preorderNote.hidden = true;
		preorderNote.textContent = '';
	}

	modal.hidden = false;
	modal.setAttribute('aria-hidden', 'false');
	document.body.classList.add('has-quick-add-open');
	renderQuickAddOptions();
	updateQuickAddState();
}

function closeQuickAddSheet() {
	var modal = document.querySelector('[data-quick-add-sheet]');
	var status = document.querySelector('[data-quick-add-status]');

	if (!modal || modal.hidden) {
		return;
	}

	modal.hidden = true;
	modal.setAttribute('aria-hidden', 'true');
	document.body.classList.remove('has-quick-add-open');
	quickAddState.card = null;
	quickAddState.product = null;
	quickAddState.selections = [];
	quickAddState.activeVariant = null;

	if (status) {
		status.textContent = '';
	}
}

function renderQuickAddOptions() {
	var optionsContainer = document.querySelector('[data-quick-add-options]');
	var product = quickAddState.product;

	if (!optionsContainer || !product || !Array.isArray(product.options)) {
		return;
	}

	optionsContainer.innerHTML = product.options
		.map(function (option, optionIndex) {
			return [
				'<div class="quick-add-sheet__option-group">',
				'<p class="quick-add-sheet__option-title">' + escapeMarkup(option.name) + '</p>',
				'<div class="quick-add-sheet__option-values">',
				(option.values || [])
					.map(function (value) {
						var isSelected = quickAddState.selections[optionIndex] === value;
						var isUnavailable = !canSelectQuickAddValue(optionIndex, value);
						return '<button class="quick-add-sheet__option-button' + (isSelected ? ' is-selected' : '') + (isUnavailable ? ' is-unavailable' : '') + '" type="button" data-quick-add-option data-option-index="' + optionIndex + '" data-option-value="' + escapeMarkup(value) + '"' + (isUnavailable ? ' disabled' : '') + '>' + escapeMarkup(value) + '</button>';
					})
					.join(''),
				'</div>',
				'</div>'
			].join('');
		})
		.join('');
}

function selectQuickAddOption(button) {
	var optionIndex = Number(button.dataset.optionIndex || 0);
	var optionValue = button.dataset.optionValue || '';

	quickAddState.selections[optionIndex] = optionValue;
	renderQuickAddOptions();
	updateQuickAddState();
}

function canSelectQuickAddValue(optionIndex, optionValue) {
	var product = quickAddState.product;
	var tentativeSelections = quickAddState.selections.slice();

	if (!product || !Array.isArray(product.variants)) {
		return false;
	}

	tentativeSelections[optionIndex] = optionValue;

	return product.variants.some(function (variant) {
		return variant.available && variant.options.every(function (value, index) {
			return !tentativeSelections[index] || tentativeSelections[index] === value;
		});
	});
}

function updateQuickAddState() {
	var product = quickAddState.product;
	var activeVariant = findMatchingVariant(product, quickAddState.selections);
	var image = document.querySelector('[data-quick-add-image]');
	var price = document.querySelector('[data-quick-add-price]');
	var link = document.querySelector('[data-quick-add-link]');
	var preorderNote = document.querySelector('[data-quick-add-preorder-note]');
	var status = document.querySelector('[data-quick-add-status]');
	var submit = document.querySelector('[data-quick-add-submit]');
	var preorderData = activeVariant && activeVariant.preorder ? activeVariant.preorder : null;
	var isPreorder = Boolean(preorderData && preorderData.enabled);

	quickAddState.activeVariant = activeVariant;

	if (image) {
		image.src = activeVariant && activeVariant.image ? activeVariant.image : product.image || '';
	}

	if (price) {
		price.textContent = activeVariant && activeVariant.price ? activeVariant.price : '';
	}

	if (link) {
		link.href = activeVariant && activeVariant.url ? activeVariant.url : product.url || '#';
	}

	if (!submit) {
		return;
	}

	if (!activeVariant) {
		submit.disabled = true;
		submit.textContent = 'Select options';
		if (preorderNote) {
			preorderNote.hidden = true;
			preorderNote.textContent = '';
		}
		if (status) {
			status.textContent = 'Select an available combination.';
		}
		return;
	}

	if (!activeVariant.available) {
		submit.disabled = true;
		submit.textContent = 'Sold out';
		if (preorderNote) {
			preorderNote.hidden = true;
			preorderNote.textContent = '';
		}
		if (status) {
			status.textContent = 'This combination is currently sold out.';
		}
		return;
	}

	submit.disabled = false;
	submit.textContent = isPreorder ? (preorderData.label || 'Pre Order') : 'Add to cart';
	if (preorderNote) {
		preorderNote.hidden = !(isPreorder && preorderData.message);
		preorderNote.textContent = isPreorder && preorderData.message ? preorderData.message : '';
	}
	if (status) {
		status.textContent = isPreorder ? (preorderData.status || 'Pre-order now.') : 'Ready to add.';
	}
}

function findMatchingVariant(product, selections) {
	if (!product || !Array.isArray(product.variants)) {
		return null;
	}

	return product.variants.find(function (variant) {
		return variant.options.every(function (value, index) {
			return selections[index] === value;
		});
	}) || null;
}

function submitQuickAdd(trigger) {
	if (!quickAddState.activeVariant || !quickAddState.activeVariant.available) {
		return;
	}

	addVariantToCart(
		quickAddState.activeVariant.id,
		trigger,
		quickAddState.activeVariant.preorder && quickAddState.activeVariant.preorder.enabled ? 'Pre-order added to cart.' : 'Added to cart',
		quickAddState.activeVariant.preorder && quickAddState.activeVariant.preorder.enabled ? quickAddState.activeVariant.preorder.properties : null
	).then(function (didAdd) {
		if (didAdd) {
			closeQuickAddSheet();
		}
	});
}

function addVariantToCart(variantId, trigger, successMessage, properties) {
	var status = document.querySelector('[data-quick-add-status]');
	var payload = {
		items: [
			{
				id: Number(variantId),
				quantity: 1
			}
		]
	};

	if (!variantId) {
		return Promise.resolve(false);
	}

	if (properties && typeof properties === 'object' && Object.keys(properties).length) {
		payload.items[0].properties = properties;
	}

	setBusyState(trigger, true);

	return fetch('/cart/add.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/json'
		},
		body: JSON.stringify({
			items: payload.items
		})
	})
		.then(function (response) {
			return response.json().catch(function () {
				return {};
			}).then(function (data) {
				if (!response.ok) {
					throw new Error(data.description || data.message || 'Unable to add this item to your cart.');
				}

				if (trigger && trigger.closest('[data-wishlist-drawer]')) {
					closeWishlistDrawer();
				}

				if (window.LauraJaneCart && typeof window.LauraJaneCart.open === 'function') {
					window.LauraJaneCart.open();
				}

				animateActionTrigger(trigger, 'is-success');
				if (status) {
					status.textContent = successMessage || 'Added to cart.';
				}

				trackLauraJaneAddToCart(variantId, trigger);

				return true;
			});
		})
		.catch(function (error) {
			if (status) {
				status.textContent = error.message;
			}

			return false;
		})
		.finally(function () {
			setBusyState(trigger, false);
		});
}

function setBusyState(element, isBusy) {
	if (!element) {
		return;
	}

	element.classList.toggle('is-loading', isBusy);
	element.setAttribute('aria-busy', isBusy ? 'true' : 'false');
	if (element.tagName === 'BUTTON') {
		element.disabled = isBusy;
	}
}

function animateActionTrigger(element, className) {
	if (!element) {
		return;
	}

	if (className) {
		element.classList.add(className);
		window.setTimeout(function () {
			element.classList.remove(className);
		}, 900);
	}

	element.classList.add('is-active');
	window.setTimeout(function () {
		element.classList.remove('is-active');
	}, 900);
}

function escapeMarkup(value) {
	return String(value || '')
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;');
}
